import React from 'react';
import styled from 'styled-components';

import { ActionButton } from '../components/Button';
import Page from '../components/Page';
import Section, { GradientSection } from '../components/Section';

import gearAboutBg from '../images/gear-about-bg.png';

const ActionBar = styled.div`
  bottom: -1em;
  left: 0;
  position: absolute;
  text-align: center;
  width: 100%;
  z-index: 1;
`;

const MainSection = styled(Section)`
  background-color: ${props => props.theme.sectionBg1};
  background-image: url(${gearAboutBg}), linear-gradient(to bottom, ${props => props.theme.sectionBg1}, ${props => props.theme.sectionBg2});
  background-repeat: no-repeat, repeat;
  background-position: right 50% bottom -150px, center;
  padding-bottom: 6em;
  h2 {
    margin: 0;
  }
`;

const AboutSection = styled(GradientSection).attrs({
  bg2: 'white'
})`
  padding-top: 3em;
`;

export default () => (
  <Page title="About Baart Group">
    <MainSection primary>
      <h2>Baart Industrial Group manufactures quality bearings and power transmission products to sell through industrial distributors.</h2>
      <ActionBar>
        <ActionButton icon="play" href="https://youtu.be/L244nRocHhE" target="_blank">Watch the video</ActionButton>
      </ActionBar>
    </MainSection>

    <AboutSection>
      <h3>Our Mission</h3>
      <p>Baart Industrial Group manufactures the highest quality bearings and power transmission components. Our mission is to supply distributors with high-quality, innovative products and solutions.</p>

      <h3>Guiding Principles</h3>
      <p><strong>People:</strong> Our employees will be treated with compassion, integrity, fairness, and respect and will be expected to treat our customers with the same values. Our employees will be encouraged to reach high levels of productivity and be rewarded for it.</p>
      <p><strong>Products:</strong> We will manufacture innovative products of the highest quality that help solve customer problems and fill customer needs at a savings.</p>
    </AboutSection>
  </Page>
);



// WEBPACK FOOTER //
// ./src/views/About.js